//@ts-nocheck

import React from "react";

const ErrorComponent = () => {
    return (
        <div className="error-404 section-title">
            <div className="container flex-container">
                <div className="blob" style={{ "--blob--color": "147, 196, 225" }}>
                    <img className="blob-mask blob-1" src="/static/img/error-404.png" alt="Error 404" />
                </div>
                <div className="text-box left">
                    <span className="tag default-fs ">ERROR</span>
                    <h1>Oh no! Please refresh the page</h1>
                    {/*<p className="large-fs">Luckily there's always more Options.</p>*/}
                    <a href="#" onClick={() => location.reload()} className="btn btn__large btn__primary large-fs" title="Refresh">Page refresh</a>
                </div>
            </div>
        </div>
    );
};

export default ErrorComponent;